<div class="email-builder-tool-settings-wrapper">
    <span class="title-row">Acknowledgement Details</span>
  
    <div class="email-builder-tool-settings-row ack-checkbox-row">
      <app-checkbox
        [formGroup]="ackForm"
        name="isDefault"
        [isLow]="true"
        label="Use as default acknowledgement template."
        [disabled]="strictReadOnly"
      ></app-checkbox>
    </div>
  
    <div class="email-builder-tool-settings-row">
      <div class="max-width-310">
        <span class="title-row ack-field-title">
          Email Subject
          <span *ngIf="isEmailSubjectRequired" class="required">*</span>
        </span>
        <app-input
          [formGroup]="ackForm"
          name="emailSubject"
          errorMassage="Email Subject"
          [low]="true"
          placeholder="Enter subject"
          [disabled]="strictReadOnly"
        ></app-input>
      </div>
    </div>
  
    <span class="title-row ack-field-title">Sender Email</span>
    <div class="email-builder-tool-settings-row">
      <div class="max-width-310">
        <app-input
          [formGroup]="ackForm"
          name="senderEmail"
          errorMassage="Sender Email"
          [low]="true"
          placeholder="Enter sender email"
          [disabled]="strictReadOnly"
        ></app-input>
      </div>
    </div>
  
    <span class="title-row ack-field-title">Sender Name</span>
    <div class="email-builder-tool-settings-row">
      <div class="max-width-310">
        <app-input
          [formGroup]="ackForm"
          name="senderName"
          errorMassage="Sender Name"
          [low]="true"
          placeholder="Enter sender name"
          [disabled]="strictReadOnly"
        ></app-input>
      </div>
    </div>
  </div>
  